var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isShowReadStatus)?_c('div',{class:{
    'message-label': true,
    'unread': _setup.isUseUnreadStyle,
    'finger-point': _setup.isHoverFingerPointer,
  },on:{"click":_setup.openReadUserPanel}},[_c('span',[_vm._v(_vm._s(_setup.readStatusText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }